module.exports = __webpack_public_path__ + "media/guitar.4ffa7575.ogg";